import React, { useState, useEffect } from 'react';

export default function FooterSection({ title, children }) {
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) setIsOpen(false);
      else setIsOpen(true);
    };

    handleResize(); 
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggle = () => {
    if (isMobile) setIsOpen(!isOpen);
  };

  return (
    <div className="footer-column">
      <h4 onClick={toggle} style={{ cursor: isMobile ? 'pointer' : 'default' }}>
        {title}
      </h4>
      <ul className={`footer-list ${isMobile && !isOpen ? 'collapsed' : ''}`}>
        {children}
      </ul>
    </div>
  );
}
